import { useLayoutEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEqual from 'lodash/isEqual';

// hooks
import useWillMount from 'hooks/useWillMount';

// actions
import { getLiveLikeChatroom, LiveLikeChatContentFilter } from 'ducks/merchantDucks/items/actions';

// selectors
import { getItemLiveLikeResources, getSavedChatroomDetails } from 'ducks/merchantDucks/items/selectors';

const useChatrooms = () => {
  const dispatch = useDispatch();

  const {
    chatrooms: [assetChatroom],
  } = useSelector(getItemLiveLikeResources);

  const { chatroomData } = useSelector(getSavedChatroomDetails);

  const isReady = useMemo(() => {
    if (!assetChatroom) {
      return true;
    }

    if (!chatroomData) {
      return false;
    }

    const ready = assetChatroom.id === chatroomData.id && assetChatroom.title === chatroomData.title;

    return ready;
  }, [assetChatroom, chatroomData]);

  useWillMount(() => {
    if (assetChatroom) {
      dispatch(getLiveLikeChatroom(String(assetChatroom.id)));
    }
  });

  return useMemo(() => ({ isReady, savedChatroom: chatroomData }), [isReady, chatroomData]);
};

export default useChatrooms;
